export default {
  oneMonth: "drl_oneMonth",
  twoMonths: "drl_twoMonths",
  threeMonths: "drl_threeMonths",
  sixMonths: "drl_sixMonths",
  oneYear: "drl_oneYear",
} as const;
